import React from "react";
import { Col, Row } from "react-bootstrap";
import DashboardHeader from "../../../components/Common/DashboardHeader";
import "./SubscriptionWorkspace.css";

export const SubscriptionWorkspace = ({
    eyebrow,
    title,
    subtitle,
    highlight,
    summaryCards = [],
    cardsLoading = false,
    showHeader = true,
    children
}) => {
    return (
        <div className="subscription-workspace">
            {showHeader && (
                <DashboardHeader
                    eyebrow={eyebrow}
                    title={title}
                    subtitle={subtitle}
                    metrics={highlight ? [{
                        key: highlight.label,
                        label: highlight.label,
                        value: highlight.value,
                        tone: "info"
                    }] : []}
                />
            )}

            {summaryCards.length > 0 && (
                <Row className="g-3 row-cols-1 row-cols-sm-2 row-cols-md-3">
                    {summaryCards.map((card) => (
                        <Col key={card.label}>
                            <SubscriptionSummaryCard {...card} loading={cardsLoading} />
                        </Col>
                    ))}
                </Row>
            )}

            {children}
        </div>
    );
};

export const SubscriptionSummaryCard = ({ label, value, valueLabel, detail, icon, tone = "slate", loading = false, subValue }) => {
    return (
        <div className={`subscription-workspace__summary-card subscription-workspace__summary-card--${tone}`}>
            <div className="subscription-workspace__summary-header">
                <span>{label}</span>
                {icon && (
                    <div className="subscription-workspace__summary-icon">
                        <i className={`fas ${icon}`}></i>
                    </div>
                )}
            </div>
            {loading ? (
                <div className="subscription-workspace__summary-loading" role="status">
                    <div className="subscription-workspace__summary-skeleton" aria-hidden="true" />
                    <div className="subscription-workspace__summary-skeleton subscription-workspace__summary-skeleton--caption" aria-hidden="true" />
                    <span>Carregando indicadores…</span>
                </div>
            ) : (
                <>
                    <strong>{value}</strong>
                    {valueLabel && <p className="subscription-workspace__summary-money">{valueLabel}</p>}
                </>
            )}
            {/* Ex: "atrasadas" já está contida em "ativas", não é categoria irmã - esse
                selo evita que o usuário some os cards de status e ache que não bate com o Total. */}
            {subValue && (
                <p className="subscription-workspace__summary-subvalue">
                    <i className="fas fa-triangle-exclamation me-1"></i>
                    {subValue}
                </p>
            )}
            {detail && <p>{detail}</p>}
        </div>
    );
};

export const SubscriptionPanel = ({ title, subtitle, action, children, className = "" }) => {
    return (
        <section className={`subscription-workspace__panel ${className}`.trim()}>
            {(title || subtitle || action) && (
                <div className="subscription-workspace__panel-header">
                    <div>
                        {title && <h5>{title}</h5>}
                        {subtitle && <p>{subtitle}</p>}
                    </div>
                    {action && <div className="subscription-workspace__panel-action">{action}</div>}
                </div>
            )}

            {children}
        </section>
    );
};
